class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 750);

        const facetForm = this.querySelector("form");
        facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

        const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
        if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

        FacetFiltersForm.getSizeAvailability();
        this.setupAnimation();
    }

    static getSizeAvailability() {
        const availabilityContainer = document.querySelector("#filter_availability");
        const availabilityContainerMobile = document.querySelector("#filter-mobile_availability");
        if (
            (!availabilityContainer || availabilityContainer.dataset.filtered > 0)
            && (!availabilityContainerMobile || availabilityContainerMobile.dataset.filtered > 0)
        ) return;

        const sizeContainer = document.querySelector("#filter_size");
        const sizeContainerMobile = document.querySelector("#filter-mobile_size");
        if (!sizeContainer || sizeContainer.dataset.filtered > 0) return;

        // Remove existing size filters
        sizeContainer.textContent = 'Getting available sizes...';
        sizeContainerMobile.textContent = 'Getting available sizes...';


        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("filter.v.availability", "1");

        fetch(`${window.location.origin}${window.location.pathname}?${searchParams.toString()}`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                const parsedHTML = new DOMParser().parseFromString(html, "text/html");
                const sizeAvailability = parsedHTML.querySelector("#filter_size");
                const sizeAvailabilityMobile = parsedHTML.querySelector("#filter-mobile_size");

                if (!sizeAvailability) return;
                sizeContainer.innerHTML = sizeAvailability.innerHTML;

                if (!sizeAvailabilityMobile) return;
                sizeContainerMobile.innerHTML = sizeAvailabilityMobile.innerHTML;
            });
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener("popstate", onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll(".js-facet-remove").forEach((element) => {
            element.classList.toggle("disabled", disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById("ProductCount");
        const countContainerDesktop = document.getElementById("ProductCountDesktop");
        document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading");
        if (countContainer) {
            countContainer.classList.add("loading");
            countContainer.textContent = 'Applying filters...';
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add("loading");
            countContainerDesktop.textContent = 'Applying filters...';
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = (element) => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);
                FacetFiltersForm.getSizeAvailability();
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.getSizeAvailability();
    }

    static renderProductGridContainer(html) {
        document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer").innerHTML;
        removeNoJS();
    }

    static renderProductCount(html) {
        const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount").innerHTML;
        const container = document.getElementById("ProductCount");
        const containerDesktop = document.getElementById("ProductCountDesktop");
        container.innerHTML = count;
        container.classList.remove("loading");
        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            containerDesktop.classList.remove("loading");
        }
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");

        const facetDetailsElements = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest(".js-filter") : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        };
        // const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
        const facetsToRender = facetDetailsElements;
        const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

        facetsToRender.forEach((element) => {
            const elementToReplace = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);

            const showMoreOpen = elementToReplace.querySelector("show-more-button")?.open;

            elementToReplace.innerHTML = element.innerHTML;

            if (showMoreOpen) {
                const showMoreButton = elementToReplace.querySelector("show-more-button");
                if (!showMoreButton) return;
                showMoreButton.open = true;
            }
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender && event.target.closest(".js-filter")) FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));

        removeTrapFocus();
        initDetailSummaries();
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = [".active-facets-mobile", ".active-facets-desktop"];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = [".mobile-facets__open", ".mobile-facets__count", ".sorting"];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents();
    }

    static renderCounts(source, target) {
        const targetElement = target.querySelector(".facets__selected");
        const sourceElement = source.querySelector(".facets__selected");

        const targetElementAccessibility = target.querySelector(".facets__summary");
        const sourceElementAccessibility = source.querySelector(".facets__summary");

        if (sourceElement && targetElement) {
            target.querySelector(".facets__selected").outerHTML = source.querySelector(".facets__selected").outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector(".facets__summary").outerHTML = source.querySelector(".facets__summary").outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
    }

    static getSections() {
        return [
            {
                section: document.getElementById("product-grid").dataset.id
            }
        ];
    }

    setupAnimation() {
        // Only apply animation setup for vertical form.
        const desktopWrapper = this.querySelector("#FacetsWrapperDesktop");
        if (!desktopWrapper) return;

        desktopWrapper.addEventListener("click", (event) => {
            // Handle clicks of summary.facets__summary.
            if (
                event.target.classList.contains("facets__summary") ||
                event.target.closest(".facets__summary")
            ) {
                const facets = event.target.closest(".js-filter");
                // If state already set to opening, remove state.
                if (facets.getAttribute('data-state') === 'opening') facets.removeAttribute('data-state');

                // Add listener for animation end to remove the data-state attribute.
                facets.addEventListener("animationend", animateEvent => {
                    if (animateEvent.animationName !== 'animateMenuOpen') return;
                    facets.removeAttribute('data-state');
                });

                facets.setAttribute('data-state', 'opening');
            }
        });
    }

    createSearchParams(form) {
        const formData = new FormData(form);

        // If size is selected, add In Stock filter.
        if (formData.get("filter.v.option.size")) formData.set("filter.v.availability", "1");

        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        const closestForm = event.target.closest("form");
        if (!closestForm) return;

        event.preventDefault();

        const uncheckCheckboxes = (checkboxes) => {
            checkboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
        };

        // if style checkbox unchecked, clear all substyle checkboxes
        if (event.target.classList.contains("js-style-check") && !event.target.checked) {
            uncheckCheckboxes(document.querySelectorAll(".js-substyle-check"));
        }

        // check if substyle checkbox has just been unchecked, if so, clear all other substyle checkboxes with this name attribute
        if (event.target.classList.contains("js-substyle-check") && !event.target.checked) {
            uncheckCheckboxes(document.querySelectorAll(`input[value="${event.target.value}"]`));
        }

        const sortFilterForms = document.querySelectorAll("facet-filters-form form");
        if (event.srcElement.className == "mobile-facets__checkbox") {
            const searchParams = this.createSearchParams(closestForm);
            this.onSubmitForm(searchParams, event);
        } else {
            const forms = [];
            const isMobile = closestForm.id === "FacetFiltersFormMobile";

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm") {
                        const noJsElements = document.querySelectorAll(".no-js-list");
                        noJsElements.forEach((el) => el.remove());
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === "FacetFiltersFormMobile") {
                    forms.push(this.createSearchParams(form));
                }
            });
            this.onSubmitForm(forms.join("&"), event);
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
        FacetFiltersForm.renderPage(url);
    }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll("input").forEach((element) => element.addEventListener("change", this.onRangeChange.bind(this)));
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll("input");
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute("max", maxInput.value);
        if (minInput.value) maxInput.setAttribute("min", minInput.value);
        if (minInput.value === "") maxInput.setAttribute("min", 0);
        if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute("min"));
        const max = Number(input.getAttribute("max"));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector("a");
        facetLink.setAttribute("role", "button");
        facetLink.addEventListener("click", this.closeFilter.bind(this));
        facetLink.addEventListener("keyup", (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
        if (typeof form.getSizeAvailability === 'function') form.getSizeAvailability();
    }
}

customElements.define("facet-remove", FacetRemove);
